export default function CheckBox({
  defaultChecked,
  checked,
  label,
  description,
  onChange,
  helperText,
}) {
  return (
    <div className="flex gap-3">
      <div className="flex h-6 shrink-0 items-center">
        <div className="group grid size-4 grid-cols-1">
          <input
            checked={defaultChecked || checked || false}
            id={label}
            name={label}
            type="checkbox"
            onChange={() => onChange(!checked)}
            aria-describedby={description}
            className="
              col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 
              bg-white checked:border-[var(--primary-color)] checked:bg-[var(--primary-color)] 
              indeterminate:border-[var(--primary-color)] indeterminate:bg-[var(--primary-color)] 
              focus:border-[var(--primary-color)] focus:text-[var(--primary-color)] hover:text-[var(--primary-color)]  focus:ring-[var(--primary-color)]
              active:border-[var(--primary-color)] active:bg-[var(--primary-color)] 
              focus-visible:outline-none 
              hover:cursor-pointer
            "
          />
          <svg
            fill="none"
            viewBox="0 0 14 14"
            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
          >
            <path
              d="M3 8L6 11L11 3.5"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="opacity-0 group-has-checked:opacity-100"
            />
            <path
              d="M3 7H11"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="opacity-0 group-has-indeterminate:opacity-100"
            />
          </svg>
        </div>
      </div>

      <div className="relative text-sm/6 pr-6">
        {" "}
        {/* add padding to make space for the icon */}
        <label htmlFor="comments" className="font-medium text-gray-900">
          {label}
        </label>
        <div className="text-gray-500">{helperText}</div>
        {/* Info icon shifted to the far right */}
        {description && (
          <div className="absolute top-1 right-0">
            <div className="group relative flex items-center justify-center">
              <div className="text-xs text-[var(--primary-color)] border border-[var(--primary-color)] rounded-full size-4 text-center leading-4 font-bold cursor-default">
                i
              </div>
              <div className="absolute left-full top-0 ml-2 w-max max-w-xs scale-0 group-hover:scale-100 transition-transform bg-white text-gray-700 text-xs px-3 py-1 rounded shadow-lg z-10 border border-gray-200">
                {description}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
